"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.utils = exports.auth = exports.payments = exports.shoutouts = exports.meetgreet = exports.artists = void 0;
exports.artists = __importStar(require("./artists"));
exports.meetgreet = __importStar(require("./meetgreet"));
exports.shoutouts = __importStar(require("./shoutouts"));
exports.payments = __importStar(require("./payments"));
exports.auth = __importStar(require("./auth"));
exports.utils = __importStar(require("./utils"));
//# sourceMappingURL=index.js.map